import React from 'react';
import {
  Question, QuestionTypes,
} from '@gamiphy/bl/survey';
import { Control } from 'react-hook-form';
import { CircularProgress } from '@mui/material';

const DatePickerQuestion = React.lazy(() => import('./datePicker'));
const SingleSelectQuestion = React.lazy(() => import('./singleSelect'));
const MultiSelectQuestion = React.lazy(() => import('./multiSelect'));
const TextQuestion = React.lazy(() => import('./text'));
const LikeDislikeQuestion = React.lazy(() => import('./likeDislike'));
const OpenEndedQuestion = React.lazy(() => import('./openEnded'));

type Props = {
  control: Control<Record<string, string | string[]>>,
  question: Question;
};

const QuestionFactory: React.FC<Props> = ({ control, question }) => {
  const questionComponent = React.useMemo(() => {
    switch (question.type) {
      case QuestionTypes.singleSelect:
        return (
          <SingleSelectQuestion
            key={question.id}
            control={control}
            question={question}
          />
        );
      case QuestionTypes.multiSelect:
        return (
          <MultiSelectQuestion
            key={question.id}
            control={control}
            question={question}
          />
        );
      case QuestionTypes.datePicker:
        return (
          <DatePickerQuestion
            key={question.id}
            control={control}
            question={question}
          />
        );
      case QuestionTypes.likeDislike:
        return (
          <LikeDislikeQuestion
            key={question.id}
            control={control}
            question={question}
          />
        );
      case QuestionTypes.openEnded:
        return (
          <OpenEndedQuestion
            key={question.id}
            control={control}
            question={question}
          />
        );
      default:
        return (
          <TextQuestion
            key={question.id}
            control={control}
            question={question}
          />
        );
    }
  }, [question, control]);

  return (
    <React.Suspense fallback={<CircularProgress color="primary" />}>
      {questionComponent}
    </React.Suspense>
  );
};

export default QuestionFactory;
